var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      width: "800",
      persistent: false,
      show_title: false,
      maxWidth: "800",
      height: "800",
      pad: "0",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-container",
              {
                staticClass:
                  "d-flex flex-wrap justify-center ma-0 pa-0 mx-auto",
                staticStyle: { "min-height": "400px" },
                attrs: { fluid: "" },
              },
              [
                _c("v-data-iterator", {
                  staticClass: "max-width d-flex flex-column",
                  attrs: {
                    items: _vm.object.selected ? _vm.object.selected : [],
                    "items-per-page": _vm.itemsPerPage,
                    page: _vm.page,
                    "hide-default-footer": "",
                    "footer-props": {
                      "items-per-page-options": [10, 20, 50],
                      "items-per-page-text": _vm.$t(
                        "label_essweb_list_components_pagenations_perpageLabel"
                      ),
                    },
                  },
                  on: {
                    "update:itemsPerPage": function ($event) {
                      _vm.itemsPerPage = $event
                    },
                    "update:items-per-page": function ($event) {
                      _vm.itemsPerPage = $event
                    },
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "no-data",
                        fn: function () {
                          return [
                            _c(
                              "v-skeleton-loader",
                              {
                                ref: "skeleton",
                                staticClass: "mx-auto",
                                attrs: {
                                  loading: _vm.Loading,
                                  boilerplate: false,
                                  type: "table-cell",
                                },
                              },
                              [_c("noContent")],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-3",
                                attrs: { justify: "start" },
                              },
                              _vm._l(props.items, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: "item---" + index,
                                    attrs: {
                                      cols: "12",
                                      sm: "2",
                                      md: "3",
                                      lg: "4",
                                    },
                                  },
                                  [
                                    _c("v-hover", {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var hover = ref.hover
                                              return [
                                                _c(
                                                  "v-skeleton-loader",
                                                  {
                                                    ref: "skeleton",
                                                    refInFor: true,
                                                    staticClass: "mx-auto",
                                                    attrs: {
                                                      loading: _vm.Loading,
                                                      boilerplate: false,
                                                      type: "table-cell",
                                                      height: 64,
                                                      transition:
                                                        "scale-transition",
                                                      origin: "center center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass:
                                                          "rounded-pill",
                                                        class: hover
                                                          ? "mrc-grey"
                                                          : "white",
                                                        attrs: {
                                                          elevation: "0",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "px-2",
                                                            attrs: {
                                                              dense: "",
                                                            },
                                                          },
                                                          [
                                                            _vm.object.avatar
                                                              ? _c(
                                                                  "v-list-item-avatar",
                                                                  [
                                                                    _c(
                                                                      "StaffAvatar",
                                                                      {
                                                                        attrs: {
                                                                          left: "",
                                                                          contentClass:
                                                                            "white--text",
                                                                          isTemp:
                                                                            item.is_temp,
                                                                          src: item.staff_avatar,
                                                                          staff_name:
                                                                            item[
                                                                              _vm
                                                                                .showKey
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            item[
                                                                              _vm
                                                                                .showKey
                                                                            ]
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    (_vm.type ==
                                                                      "select" &&
                                                                      _vm.datatype ==
                                                                        "all_staff") ||
                                                                    (_vm.type ==
                                                                      "select" &&
                                                                      _vm.datatype ==
                                                                        "staff")
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "text--secondary text-caption-xs",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item[
                                                                                  _vm
                                                                                    .selectKey
                                                                                ]
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                                _vm.object
                                                                  .twoLine
                                                                  ? _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                item[
                                                                                  _vm
                                                                                    .subKey
                                                                                ]
                                                                                  ? item[
                                                                                      _vm
                                                                                        .subKey
                                                                                    ]
                                                                                  : ""
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-action",
                                                              {
                                                                staticClass:
                                                                  "my-0",
                                                              },
                                                              [
                                                                hover
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          icon: "",
                                                                          color:
                                                                            "grey",
                                                                          ripple: false,
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.select(
                                                                                item
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "material-icons-round md-18 text--secondary",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "cancel"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ]
                        },
                      },
                      _vm.showFooter
                        ? {
                            key: "footer",
                            fn: function (props) {
                              return [
                                _c("v-spacer"),
                                _vm.object.selected &&
                                _vm.object.selected.length &&
                                _vm.object.selected.length > _vm.itemsPerPage
                                  ? _c("Pagenations", {
                                      attrs: {
                                        dense: "",
                                        options: props,
                                        filterpage: _vm.page,
                                        "show-item-pages": false,
                                        filterItemsPerPage: _vm.itemsPerPage,
                                        items: _vm.object.selected
                                          ? _vm.object.selected
                                          : [],
                                      },
                                      on: { change: _vm.onChange },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }